import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'startsWith'
})
export class StartsWithPipe implements PipeTransform {

  transform(values: any[], fieldName : string, value : string): any[] {
    return values.filter(v => v[fieldName] !== undefined && ("" + v[fieldName]).startsWith(value));
  }

}
